import Header from "./Header";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useState } from "react";
import validator from "validator";
import Nprogress from 'nprogress';

const Registpage = () => {
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setNumber] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // Visibility state
  const [loading, setLoading] = useState(false);
  const Navigates = useNavigate();

  // Safely sanitizes incoming raw text input
  const CleanInput = (value) => {
    return validator.escape(value.trim());
  };

  // Trailing whitespace removed while protecting specific salt structures
  const CleanPassword = (value) => {
    return value.trim();
  };

  function Handlevalidation() {
    const emailRegx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const passwordRegex = /^.{6,10}$/;
    const PhonenumberRegx = /^07[2389][0-9]{7}$/;
    
    const Validationlogic = [
      { condition: name === "", message: "Provide Your Name!" },
      { condition: email === "", message: "Provide Your Email!" },
      { condition: phoneNumber === "", message: "Provide Your Phone Number!" },
      { condition: password === "", message: "Provide Your Password!" },
      { condition: !emailRegx.test(email), message: "Invalid structure of email!" },
      { condition: !PhonenumberRegx.test(phoneNumber), message: "Invalid structure of phone number!" },
      { condition: !passwordRegex.test(password), message: "Password must be 6–10 characters long!" }
    ];

    const errorResult = Validationlogic.find((v) => v.condition);
    if (errorResult) {
      setError(errorResult.message);
    } else {
      setError(""); 
      Handleregist();
    }
  }

  async function Handleregist() {
    Nprogress.start();
    setLoading(true);
    
    const API_URL = import.meta.env.VITE_API_BASE_URL || 'https://land-survey-main-server.onrender.com';

    try {
      const response = await axios.post(`${API_URL}/regist`, {
        name,
        email,
        phoneNumber,
        password,
      });

      Nprogress.done();

      if (response.data.status === true) {
        alert(response.data.message);
        Navigates("/login");
        return;
      }

      if (response.data.errors) {
        const errors = response.data.errors;
        const firstErrorMsg = Object.values(errors)[0]?.msg || "Validation validation failed.";
        setError(firstErrorMsg);
        return;
      }

      if (response.data.message) {
        setError(response.data.message);
        alert(response.data.message);
      } else {
        setError("An unknown response format was received from the server.");
      }

    } catch (err) {
      Nprogress.done();
      console.error("Critical Registration Error Log:", err);

      if (err.response) {
        const serverData = err.response.data;

        if (serverData && serverData.errors) {
          const errors = serverData.errors;
          setError(
            errors.name?.msg ||
            errors.email?.msg ||
            errors.phoneNumber?.msg ||
            errors.password?.msg ||
            "Data validation failed on server verification."
          );
        } 
        else if (serverData && serverData.message) {
          setError(serverData.message);
        } 
        else {
          setError(`Server Error (${err.response.status}): ${err.response.statusText || "Internal Processing Failed"}`);
        }
      } 
      else if (err.request) {
        setError("No response received. The backend server might be offline or your connection timed out.");
      } 
      else {
        setError(`Application Error: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  }

  const inputStyles =
    "w-full pb-1 text-white bg-transparent border-b-2 border-white/40 focus:border-blue-400 outline-none transition-colors duration-300 [transition:background-color_50000s_ease-in-out_0s,_color_50000s_ease-in-out_0s] autofill:bg-transparent autofill:text-white pr-10";

  return (
    <div
      className="flex flex-col justify-between w-full min-h-screen overflow-x-hidden bg-center bg-no-repeat bg-cover"
      style={{ backgroundImage: "url('/images/image21.webp')" }}
    >
      <Header />

      <div className="flex items-center justify-center flex-grow px-4 py-10 md:py-16">
        <div className="w-full max-w-md p-6 border shadow-2xl sm:p-8 md:p-10 border-white/20 rounded-2xl backdrop-blur-xl bg-black/30">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              Handlevalidation();
            }}
            className="flex flex-col gap-5"
          >
            <div className="text-center">
              <h2 className="mb-1 text-3xl font-bold tracking-wide text-white">
                Create Account
              </h2>
              <p className="text-sm text-white/60">
                Join us by filling out the details below
              </p>
            </div>

            {error && (
              <div className="bg-red-500/20 border border-red-500/50 rounded-lg p-2.5 text-center">
                <p className="text-sm font-medium text-red-400">{error}</p>
              </div>
            )}

            <div>
              <label className="text-white/80 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                Enter Your Name
              </label>
              <input
                type="text"
                required
                className={inputStyles}
                onChange={(e) => setName(CleanInput(e.target.value))}
              />
            </div>

            <div>
              <label className="text-white/80 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                Enter Your Email
              </label>
              <input
                type="email"
                required
                className={inputStyles}
                onChange={(e) => setEmail(CleanInput(e.target.value))}
              />
            </div>

            <div>
              <label className="text-white/80 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                Enter Your Phone Number
              </label>
              <input
                type="text"
                required
                className={inputStyles}
                onChange={(e) => setNumber(CleanInput(e.target.value))}
              />
            </div>

            <div>
              <label className="text-white/80 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                Enter Password
              </label>
              <div className="relative w-full">
                <input
                  type={showPassword ? "text" : "password"}
                  required
                  className={inputStyles}
                  onChange={(e) => setPassword(CleanPassword(e.target.value))}
                />
                
                {/* ICON TOGGLE BUTTON */}
                <button
                  type="button"
                  className="absolute transition-colors duration-200 right-2 bottom-2 text-white/50 hover:text-blue-400 focus:outline-none"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    /* Eye Off Icon (Slash through eye) */
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                    </svg>
                  ) : (
                    /* Eye Icon (Open eye) */
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <div className="flex items-center gap-3 py-1">
              <input
                type="checkbox"
                id="terms"
                className="w-4 h-4 text-blue-600 border-gray-300 rounded cursor-pointer focus:ring-blue-500 accent-blue-500"
              />
              <label
                htmlFor="terms"
                className="text-sm transition-colors cursor-pointer select-none text-white/90 hover:text-white"
              >
                I Agree to the Terms & Conditions
              </label>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 mt-2 font-semibold text-white tracking-wide rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 active:scale-[0.98] transition-all duration-200 shadow-lg shadow-blue-500/20 flex items-center justify-center gap-2"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-white rounded-full border-t-transparent animate-spin"></div>
              ) : (
                "Register"
              )}
            </button>

            <div className="mt-2 text-center">
              <Link
                to="/login"
                className="text-sm text-white/70 hover:text-white border-b border-transparent hover:border-white transition-all duration-200 pb-0.5"
              >
                Already have an account? Login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Registpage;